import bootstrap from "bootstrap/dist/js/bootstrap.js";

export const showAlert = (el, message, type = 'info') => {

    if (typeof el === 'string') {
        el = document.querySelector(el);
    }
    if (!el) {
        console.warn("No element found to show alert");
        return;
    }

    el.innerHTML = `
    <div class="alert alert-${type} alert-dismissible fade show" role="alert">
      ${message}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
  `;
}

export const showToast = (message, type = "info", delay = 3000) => {
    const toastContainer = document.getElementById("toastContainer");

    // vytvoříme wrapper
    const toastEl = document.createElement("div");
    toastEl.className = `toast mb-2`;
    toastEl.setAttribute("role", "alert");
    toastEl.setAttribute("aria-live", "assertive");
    toastEl.setAttribute("aria-atomic", "true");

    toastEl.innerHTML = `
   <div class="alert alert-${type} alert-dismissible fade show m-0" role="alert">
      ${message}
      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
  `;

    toastContainer.insertBefore(toastEl, null);

    // inicializace Bootstrap toastu
    const bsToast = new bootstrap.Toast(toastEl, {delay});
    bsToast.show();

    // po skrytí odebereme element
    toastEl.addEventListener("hidden.bs.toast", () => toastEl.remove());
}